import { createAsyncThunk } from "@reduxjs/toolkit";
import { CatalogService } from "./catalog";

export class CatalogActions {
  // Validate whatsappConfigData Settings
  static getCatalogConfigData = createAsyncThunk(
    "facebookSettingsSlice/CatalogConfigData",
    (data: any, { dispatch, rejectWithValue }) => {
      return CatalogService.getCatalogConfig()
        .then(async (response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    },
  );

  static catalogConfigData = createAsyncThunk(
    "facebookSettingsSlice/catalogConfigData",
    (data: any, { dispatch, rejectWithValue }) => {
      return CatalogService.CatalogConfigData(data)
        .then(async (response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    },
  );

  static setCatalogId = createAsyncThunk(
    "facebookSettingsSlice/setCatalogId",
    (data: any, { dispatch, rejectWithValue }) => {
      return CatalogService.setCatalogId(data)
        .then(async (response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    },
  );

  // Validate whatsappConfigData Settings
  static getCatalogList = createAsyncThunk(
    "facebookSettingsSlice/getCatalogList",
    ({}: any, { dispatch, rejectWithValue }) => {
      return CatalogService.getCatalogList()
        .then(async (response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    },
  );

  static getCatalogProductList = createAsyncThunk(
    "facebookSettingsSlice/getCatalogProductList",
    (data: any, { dispatch, rejectWithValue }) => {
      return CatalogService.getCatalogProductList(data)
        .then(async (response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    },
  );

  static getCatalogProductCollection = createAsyncThunk(
    "facebookSettingsSlice/getCatalogProductCollection",
    (data: any, { dispatch, rejectWithValue }) => {
      return CatalogService.getCatalogProductCollection(data)
        .then(async (response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    },
  );

  static syncCatalogProductCollection = createAsyncThunk(
    "facebookSettingsSlice/syncCatalogProductCollection",
    (data: any, { dispatch, rejectWithValue }) => {
      return CatalogService.syncCatalogProductCollection(data)
        .then(async (response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    },
  );

    static shopifyProductSync = createAsyncThunk(
      "ContactListSlice/shopifyProductSync",
      (dispatch, rejectWithValue) => {
        return CatalogService.shopifyProductSync({})
          .then(async (response: any) => {
            return response;
          })
          .catch((error: { response: unknown }) => {
            // return rejectWithValue(error?.response);
          })
          .finally(() => { });
      }
    );

    static getShopifyProductSync = createAsyncThunk(
      "ContactListSlice/getShopifyProductSync",
      (dispatch, rejectWithValue) => {
        return CatalogService.getShopifyProductSync({})
          .then(async (response: any) => {
            return response;
          })
          .catch((error: { response: unknown }) => {
            // return rejectWithValue(error?.response);
          })
          .finally(() => { });
      }
    );
  // // Validate whatsappConfigData Settings
  // static logoutFacebookConfiguration = createAsyncThunk(
  //   "facebookSettingsSlice/logoutFacebookConfiguration",
  //   ({}: any, { dispatch, rejectWithValue }) => {
  //     return FacebookSettingsService.logoutFacebookConfiguration({})
  //       .then(async (response: any) => {
  //         return response;
  //       })
  //       .catch((error: { response: unknown }) => {
  //         return rejectWithValue(error?.response);
  //       })
  //       .finally(() => {});
  //   },
  // );

  // static disconnectSingleFacebookPage = createAsyncThunk(
  //   "facebookSettingsSlice/disconnectSingleFacebookPage",
  //   (data: any, { dispatch, rejectWithValue }) => {
  //     return FacebookSettingsService.disconnectSingleFbPage(data)
  //       .then(async (response: any) => {
  //         return response;
  //       })
  //       .catch((error: { response: unknown }) => {
  //         return rejectWithValue(error?.response);
  //       })
  //       .finally(() => {});
  //   },
  // );
}
